export const enum CoverageType {
  FromTV = 'from_tv',
  FromVenue = 'from_venue',
  Basic = 'basic',
}
